import { useTranslation } from 'react-i18next'

import { Flex, Skeleton, Text } from '@chakra-ui/react'

import { Size } from '../types/types'
import type { FloorPlanVisualVariant } from '../utils/floorPlanVisuals'

export const FloorPlanPlaceholder = ({
  fetching,
  imageSize,
  imageUrl,
  textColor,
  visualVariant = 'legacy',
}: {
  fetching?: boolean
  imageSize?: Size
  imageUrl?: string
  textColor?: string
  visualVariant?: FloorPlanVisualVariant
}) => {
  const { t } = useTranslation()
  const shouldFillCanvas = visualVariant === 'rebrand'

  // if fetching or loading an image
  if (fetching || (!fetching && imageUrl && !imageSize)) {
    return (
      <Skeleton
        bottom={shouldFillCanvas ? 0 : undefined}
        data-testid='floorPlan_skeleton'
        height={shouldFillCanvas ? '100%' : '90%'}
        left={shouldFillCanvas ? 0 : undefined}
        m={shouldFillCanvas ? 0 : 'auto'}
        pos='absolute'
        right={shouldFillCanvas ? 0 : undefined}
        rounded={shouldFillCanvas ? 'none' : 'md'}
        top={shouldFillCanvas ? 0 : undefined}
        width={shouldFillCanvas ? '100%' : '94%'}
      />
    )
  }

  if (!fetching && !imageUrl) {
    return (
      <Flex
        alignItems='center'
        height='100%'
        justifyContent='center'
        pos='relative'
        width='100%'
      >
        <Text color={shouldFillCanvas ? textColor : undefined}>
          {t('floors:plan_placeholder_no_floor_plan')}
        </Text>
      </Flex>
    )
  }

  return null
}
